"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustoText = void 0;

var errors_1 = require("../utils/errors");

var CustoText =
/** @class */
function () {
  function CustoText(text) {
    this.$$end$$ = true;
    this.text = text;
  }

  CustoText.create = function (text) {
    return new CustoText(text);
  };

  CustoText.prototype.getRaw = function () {
    return this.text;
  };

  CustoText.prototype.useTransformed = function (props, textTransformer) {
    if (props === void 0) {
      props = {};
    }

    var transformed;

    try {
      transformed = textTransformer ? textTransformer(this.text) : this.text;
    } catch (e) {
      if (!(e instanceof errors_1.CustoTypeError)) throw e;
      transformed = this.text;
    }

    if (props.disableTextTransformer) transformed = this.text;
    return transformed;
  };

  CustoText.prototype.render = function (props, textTransformer) {
    var transformed = this.useTransformed(props, textTransformer);
    if (typeof transformed === "number") return transformed.toString();
    return transformed;
  };

  CustoText.prototype.clone = function () {
    return new CustoText(this.text);
  };

  return CustoText;
}();

exports.CustoText = CustoText;